
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"3","y":"3","width":"18","height":"19"}},[_c('path',{attrs:{"d":"M15.945 9.667a1.5 1.5 0 01-1.435-1.064l-1.076-3.544c-.431-1.419-2.44-1.419-2.871 0L9.487 8.603a1.5 1.5 0 01-1.435 1.064H5.017c-1.46 0-2.06 1.873-.871 2.72l2.514 1.795a1.5 1.5 0 01.562 1.665l-1.038 3.35c-.431 1.394 1.18 2.521 2.341 1.638l2.566-1.95a1.5 1.5 0 011.815-.001l2.58 1.958c1.162.882 2.77-.245 2.34-1.638l-1.04-3.358a1.5 1.5 0 01.56-1.664l2.512-1.795c1.187-.848.587-2.72-.872-2.72h-3.041z","fill":"#EDC843"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M12.716 5.277l1.076 3.543a2.25 2.25 0 002.153 1.597h3.04c.73 0 1.03.936.437 1.36l-2.511 1.795a2.25 2.25 0 00-.841 2.496l1.04 3.357c.215.697-.59 1.26-1.17.82l-2.58-1.959a2.25 2.25 0 00-2.723.002l-2.566 1.95c-.58.442-1.386-.122-1.17-.819l1.037-3.35a2.25 2.25 0 00-.842-2.497L4.58 11.777c-.594-.424-.294-1.36.436-1.36h3.035a2.25 2.25 0 002.152-1.597l1.077-3.543c.215-.71 1.22-.71 1.435 0z","stroke":"#EDC843","stroke-width":"1.5"}}),_c('path',{staticClass:"first-half",attrs:{"d":"M12 4H3v18h9V4z","fill":"#EDC843"}}),_c('path',{staticClass:"second-half",attrs:{"d":"M21 4h-9v18h9V4z","fill":"#EDC843"}})])])
          )
        }
      }
    